import { Controller } from '@hotwired/stimulus';

/**
 * eKYC選択時の確認ダイアログを表示するコントローラー
 *
 * 使用方法:
 * <form data-controller="ekyc-form"
 *       data-ekyc-form-confirm-message-value="確認メッセージ">
 *   <input type="radio" name="identity_verification_type[category]" value="ekyc">
 *   ...
 * </form>
 */
export default class extends Controller {
  static values = {
    confirmMessage: String
  };

  connect() {
    this.boundHandleSubmit = this.handleSubmit.bind(this);
    this.element.addEventListener('submit', this.boundHandleSubmit);
  }

  disconnect() {
    this.element.removeEventListener('submit', this.boundHandleSubmit);
  }

  handleSubmit(e) {
    const selectedRadio = this.element.querySelector('input[name="identity_verification_type[category]"]:checked');
    if (selectedRadio && selectedRadio.value === 'ekyc') {
      if (!this.hasConfirmMessageValue) {
        return;
      }
      const confirmed = confirm(this.confirmMessageValue);
      if (!confirmed) {
        e.preventDefault();
      }
    }
  }
}
